import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ConfigurationFeatureFlag } from '@tink/config/src/tinkLinkConfig';
import { ProviderEntity } from '../../../../../models/provider';
import { ScopeItem } from '../../../../../lib-api/services/Oauth';
import { DocumentOverlayLink } from '../molecules/DocumentOverlayLink/DocumentOverlayLink';
import { getLanguageCode } from '../../../../../utilities/utils';
import { PageView } from '../../../../../models/analytics';
import { useUrlQuery } from '../../../../ApplicationProviders/UrlQueryProvider/UrlQueryProvider';
import { getTermsAndConditionsMarketUrl } from '../../../../../core/screens/Legal/TermsAndConditions/TermsAndConditionsMarket';
import { getPrivacyPolicyMarketUrl } from '../../../../../core/screens/Legal/PrivacyPolicy/PrivacyPolicyMarket';
import { messages } from './messages';

export type TinkLegalDisclaimerConsentProps = {
  clientName: string;
  clientUrl: string;
  provider: ProviderEntity | undefined;
  scopesDescriptionsList: ScopeItem[];
  featureFlags: ConfigurationFeatureFlag[];
};

export const TinkLegalDisclaimerConsent: React.FC<TinkLegalDisclaimerConsentProps> = ({
  featureFlags,
}) => {
  const { locale, market } = useUrlQuery();
  const languageCode = getLanguageCode(locale);

  const hideLegalText = featureFlags.includes(ConfigurationFeatureFlag.CREDENTIAL_TERMS_HIDDEN);

  return (
    <div data-testid="legal-disclaimer-auth">
      {!hideLegalText && (
        <FormattedMessage
          {...messages.termsAndConditionsMessage}
          values={{
            privacyPolicy: (
              <DocumentOverlayLink
                documentUrl={getPrivacyPolicyMarketUrl({ market, language: languageCode })}
                pageView={PageView.PRIVACY_POLICY_SCREEN}
              >
                <FormattedMessage {...messages.privacyPolicy} />
              </DocumentOverlayLink>
            ),
            termsAndConditions: (
              <DocumentOverlayLink
                documentUrl={getTermsAndConditionsMarketUrl({ market, language: languageCode })}
                pageView={PageView.TERMS_AND_CONDITION_SCREEN}
              >
                <FormattedMessage {...messages.termsAndConditions} />
              </DocumentOverlayLink>
            ),
          }}
        />
      )}
    </div>
  );
};
